import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronTriangleUpMedium"><Path d="M10.8514 8.20109C11.4508 7.48767 12.5489 7.48764 13.1483 8.20109L16.7889 12.5351C17.6084 13.5109 16.9147 14.9997 15.6405 14.9999H8.3592C7.08476 14.9998 6.39103 13.5109 7.21076 12.5351L10.8514 8.20109Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
